'use client';

import React, { useRef } from 'react';
import Icon from '@/components/ui/AppIcon';
import MovieCard, { Movie } from '@/components/ui/MovieCard';

const similarMovies: Movie[] = [
{ id: 'sim-001', title: 'The Dark Knight', year: 2008, genre: ['Action', 'Crime', 'Drama'], rating: 4.9, reviewCount: 45230, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1bef05f13-1772376525645.png", posterAlt: 'Dark cinematic film projector light in theater', badge: 'top-rated', runtime: 152 },
{ id: 'sim-002', title: 'Dunkirk', year: 2017, genre: ['Drama', 'History', 'War'], rating: 4.3, reviewCount: 18760, poster: "https://images.unsplash.com/photo-1642503462075-62fcdd9611b3", posterAlt: 'Dramatic wartime beach scene with boats', runtime: 106 },
{ id: 'sim-003', title: 'Interstellar', year: 2014, genre: ['Sci-Fi', 'Drama', 'Adventure'], rating: 4.7, reviewCount: 38920, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_166b322c4-1772728889934.png", posterAlt: 'Cosmic space scene with galaxy and stars', badge: 'top-rated', runtime: 169 },
{ id: 'sim-004', title: 'Tenet', year: 2020, genre: ['Action', 'Sci-Fi', 'Thriller'], rating: 3.8, reviewCount: 14230, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_19193b306-1785350645460.png", posterAlt: 'Desert landscape representing time manipulation thriller', runtime: 150 },
{ id: 'sim-005', title: 'Killers of the Flower Moon', year: 2023, genre: ['Drama', 'History', 'Crime'], rating: 4.5, reviewCount: 11240, poster: "https://images.unsplash.com/photo-1730828550968-3bd9456b58c2", posterAlt: 'Vast American plains at golden hour', runtime: 206 },
{ id: 'sim-006', title: 'The Zone of Interest', year: 2023, genre: ['Drama', 'History'], rating: 4.4, reviewCount: 6780, poster: "https://images.unsplash.com/photo-1703482475895-27749507eeef", posterAlt: 'Quiet countryside home surrounded by green trees', badge: 'staff-pick', runtime: 105 }];


export default function SimilarMoviesRow() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir === 'left' ? -300 : 300, behavior: 'smooth' });
  };

  return (
    <section className="mt-12 mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="w-1 h-5 bg-gold rounded-full" />
          <h2 className="text-lg font-700 text-foreground">More Like This</h2>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => scroll('left')} className="btn-ghost p-2 rounded-lg" aria-label="Scroll left">
            <Icon name="ChevronLeftIcon" size={16} className="text-muted-foreground" />
          </button>
          <button onClick={() => scroll('right')} className="btn-ghost p-2 rounded-lg" aria-label="Scroll right">
            <Icon name="ChevronRightIcon" size={16} className="text-muted-foreground" />
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto scrollbar-hide pb-4">
        {similarMovies.map((movie) =>
        <MovieCard key={movie.id} movie={movie} size="md" />
        )}
      </div>
    </section>);

}